import { render, staticRenderFns } from "./StatsBar.vue?vue&type=template&id=70a9ec92&"
import script from "./StatsBar.vue?vue&type=script&lang=js&"
export * from "./StatsBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports